export const constDeMeeuwAddress =
'VDL De Meeuw\nIndustrieweg 8\n5688 DP Oirschot';
export const constNrOfLinesInOnePdfPage = 65;
